import { useMemo } from 'react';
import { customerClassificationIconNameHandler, mapCustomerClassifications } from '@mews-commander/utils';

export interface UseCustomerClassificationsParams {
    classifications: number;
}

// TODO: migrate to new customerClassifications data format
export const useCustomerClassificationsSplit = ({ classifications }: UseCustomerClassificationsParams) =>
    useMemo(() => {
        const classificationsMap = mapCustomerClassifications(classifications).map((item) => ({
            enumValue: item.name,
            iconName: customerClassificationIconNameHandler(item.value)?.iconName,
        }));
        const [first, ...other] = classificationsMap;

        return { first, other };
    }, [classifications]);
